import React from "react";
import "./QuickContactCards.css";

import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const QuickContactCards = () => {
  return (
    <section className="oglitz-quick-contact">
      <div className="oglitz-quick-contact-container">
        {/* HEADER */}
        <div className="oglitz-quick-contact-header">
          <span className="oglitz-quick-contact-badge">Quick Contact</span>

          <h2>
            Reach Us <span>Instantly</span>
          </h2>

          <p>
            Connect with Oglitz Software through your preferred channel. Our
            team responds quickly across India and Dubai business hours.
          </p>
        </div>

        {/* CARDS */}
        <div className="oglitz-quick-contact-grid">
          {/* CALL */}
          <a href="tel:+919532119007" className="oglitz-qc-card">
            <div className="oglitz-qc-icon call">
              <PhoneInTalkIcon />
            </div>
            <h4>Call Us</h4>
            <span>+91 95321 19007</span>
            <p>Speak directly with our team</p>
          </a>

          {/* EMAIL */}
          <a href="mailto:info@oglitz.com" className="oglitz-qc-card">
            <div className="oglitz-qc-icon email">
              <MailOutlineIcon />
            </div>
            <h4>Email Us</h4>
            <span>info@oglitz.com</span>
            <p>For business inquiries & support</p>
          </a>

          {/* WHATSAPP INDIA */}
          <a
            href="https://wa.me/919532119007"
            target="_blank"
            rel="noopener noreferrer"
            className="oglitz-qc-card highlight"
          >
            <div className="oglitz-qc-icon whatsapp">
              <WhatsAppIcon />
            </div>
            <h4>WhatsApp (India)</h4>
            <span>+91 95321 19007</span>
            <p>Fastest response for India clients</p>
          </a>

          {/* WHATSAPP DUBAI */}
          <a
            href="https://wa.me/971568729406"
            target="_blank"
            rel="noopener noreferrer"
            className="oglitz-qc-card"
          >
            <div className="oglitz-qc-icon whatsapp dubai">
              <WhatsAppIcon />
            </div>
            <h4>WhatsApp (Dubai)</h4>
            <span>+971 56 872 9406</span>
            <p>Middle East client support</p>
          </a>

          {/* LOCATION */}
          <div className="oglitz-qc-card">
            <div className="oglitz-qc-icon location">
              <LocationOnIcon />
            </div>
            <h4>Our Offices</h4>
            <span>India & Dubai</span>
            <p>Global delivery & operations</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickContactCards;
